// 报告归档 — M8 已切真后端（report_archives 表）
// M9 报告生成器上线前，列表可能为空（没有归档记录）
// 后端 schema: app/schemas/report.py
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export type ReportType = 'weekly' | 'monthly' | 'yearly'

export interface ReportItem {
  id: number
  type: ReportType
  title: string
  periodStart: string
  periodEnd: string
  generatedAt: number
  htmlPath: string
  pdfPath: string | null
  mdPath: string | null
  size: string
  highlights: string[]
}

export interface UseReportListParams {
  type?: ReportType
}

interface ReportListResponse {
  items: ReportItem[]
  total: number
}

export function useReportList(params: UseReportListParams = {}) {
  return useQuery({
    queryKey: ['reports', 'list', params],
    queryFn: async () => {
      const qp = new URLSearchParams()
      if (params.type) qp.set('type', params.type)
      const q = qp.toString()
      const resp = await get<ReportListResponse>(`/reports${q ? `?${q}` : ''}`)
      return resp.items
    },
  })
}
